module.exports = require("./fr-TD.js");